import { render } from "./loginPubilc.vue?vue&type=template&id=3fe3096a"
import script from "./loginPubilc.vue?vue&type=script&lang=js"
export * from "./loginPubilc.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\ncc-projectlib\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__